'use strict';
import angular from 'angular';
import ngMaterial from 'angular-material';
import PracticeManagementController from './practice-management.controller';
import buildingAnexpertDispensaryForm from './building-an-expert-dispensary';
import optimizingClinicalOperations from './optimizing-clinical-operations';
import masteringSalesAndMarketing from './mastering-sales-and-marketing';
import leveragingTechnology from './leveraging-technology';
import enhancingPatientCompliance from './enhancing-patient-compliance';
export default angular.module('eeComUiApp.practiceManagement', [
    ngMaterial,
    buildingAnexpertDispensaryForm,
    optimizingClinicalOperations,
    masteringSalesAndMarketing,
    leveragingTechnology,
    enhancingPatientCompliance
])
    .controller('PracticeManagementController', PracticeManagementController)
    .name;
//# sourceMappingURL=index.js.map